import { Box, ClickAwayListener, Input, alpha, styled } from '@mui/material'
import { useIntl } from 'react-intl'

import useMobileBuilder from 'features/builder/ui/useMobileBuilder'
import useMapTitleEditor from './useMapTitleEditor'
import { Typography } from '@carto/meridian-ds/components'

const InputWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  paddingLeft: theme.spacing(1)
}))

const InputSpacer = styled(Typography)(() => ({
  opacity: 0,
  pointerEvents: 'none'
}))

const TitleInput = styled(Input)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  opacity: 1,

  '&:before, &:after': {
    content: 'none'
  },
  '&.Mui-focused:before': {
    opacity: 1
  },

  '& input::placeholder, &.Mui-disabled input::placeholder': {
    color: alpha(theme.palette.brand.appBarContrastText, 0.6)
  },

  '& input': {
    ...theme.typography.body2,
    color: theme.palette.brand.appBarContrastText,
    fontWeight: 500,
    maxWidth: '100%',
    minWidth: theme.spacing(7),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: '1px',

    '&.Mui-disabled': {
      WebkitTextFillColor: theme.palette.brand.appBarContrastText
    }
  }
}))

function MapTitleEditor() {
  const intl = useIntl()
  const isMobile = useMobileBuilder()

  const { mapTitle, mapTitleSpacerContent, handleTitleSelection, handleTitleChange, handleKeyDown, saveMapTitle } =
    useMapTitleEditor()

  if (isMobile) return null

  return (
    <InputWrapper>
      <InputSpacer variant="body2" weight="strong">
        {mapTitleSpacerContent}
      </InputSpacer>
      <ClickAwayListener onClickAway={saveMapTitle}>
        <TitleInput
          placeholder={intl.formatMessage({ id: 'maps.default.title' })}
          value={mapTitle || ''}
          onClick={handleTitleSelection}
          onChange={handleTitleChange}
          onKeyDown={handleKeyDown}
          fullWidth={true}
          inputProps={{ 'aria-label': 'map-name', 'data-testid': 'map-title-editor' }}
        />
      </ClickAwayListener>
    </InputWrapper>
  )
}

export default MapTitleEditor
